export default __webpack_public_path__ + "images/logo-schroff.svg?d94146dcc0912d4cebe322c925f5ab8a";